import { FLOWCODE_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { IthacaJwt } from '@dtx-company/ithaca-sdk/src'
import { ParamsType } from '../../../constants/charts'
import { PixelApiRequestParams } from '@app/analytics/src/components/Conversions/types'

export const baseApiUri = FLOWCODE_API_ENDPOINT + '/analytics'

export const prepParams = (
  params: ParamsType | PixelApiRequestParams | URLSearchParams
): string => {
  const paramsWithTimezone = {
    ...params,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }
  return new URLSearchParams(paramsWithTimezone as URLSearchParams).toString()
}

export const getHeaders = (token: IthacaJwt | null): Record<string, string> => {
  return {
    authorization: `Bearer ${token?.token}`,
    Accept: 'application/json'
  }
}
